module.exports = __webpack_public_path__ + "static/img/intro.f147fa3e.png";